__turbopack_context__.v({
  "customCheckbox": "MGS15q_customCheckbox",
  "noItemsMessage": "MGS15q_noItemsMessage",
  "title": "MGS15q_title",
  "wrapper": "MGS15q_wrapper",
});
